import { useQuery } from "@tanstack/react-query";
import { mapInfractionDetail } from "../handlers/map-infraction-detail";
import { getInfractionById } from "../services/infractions.service";
import type { InfractionDetailApiResponse } from "../types/infraction-api.types";
import { infractionQueryKeys } from "./infraction-query-keys";

const INFRACTION_DETAIL_STALE_TIME_MS = 5 * 60 * 1000;

function fetchInfractionDetail(
	infractionId: string
): Promise<InfractionDetailApiResponse> {
	return getInfractionById(Number(infractionId));
}

function getInfractionDetailQueryOptions(infractionId: string | null) {
	return {
		queryKey: infractionQueryKeys.detail(infractionId),
		queryFn: () => {
			if (!infractionId) {
				throw new Error("Infraction id is required.");
			}

			return fetchInfractionDetail(infractionId);
		},
		staleTime: INFRACTION_DETAIL_STALE_TIME_MS,
	};
}

export function useInfractionDetail(
	infractionId: string | null,
	enabled: boolean
) {
	return useQuery({
		...getInfractionDetailQueryOptions(infractionId),
		select: mapInfractionDetail,
		enabled: enabled && Boolean(infractionId),
	});
}

export function useInfractionDetailRaw(
	infractionId: string | null,
	enabled: boolean
) {
	return useQuery({
		...getInfractionDetailQueryOptions(infractionId),
		enabled: enabled && Boolean(infractionId),
		/** Always refetch on edit open so attachments reflect the latest desired state. */
		refetchOnMount: "always",
	});
}
